<template>
	<div>
		<div style="margin-bottom: 20px;padding-left: 10px;">
			<el-page-header @back="goBack" content="添加菜单">
			</el-page-header>
		</div>
		<el-card class="box-card">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="菜单" name="first">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="菜单名称">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="所属菜单">
							<el-input v-model="form.menu" readonly @click.native="dialogFormVisible = true"></el-input>
						</el-form-item>
						<el-form-item label="url">
							<el-input v-model="form.url"></el-input>
						</el-form-item>
						<el-form-item label="图标">
							<el-input v-model="form.ico" readonly @click.native="dialogVisible = true">
							</el-input>
						</el-form-item>
						<el-form-item label="排序">
							<el-input v-model="form.sort"></el-input>
						</el-form-item>
						<el-form-item label="状态">
							<el-switch v-model="form.status" active-color="#13ce66" inactive-color="#dcdfe6">
							</el-switch>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSubmit()">确认</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="按钮" name="second">
					<el-form ref="form" :model="btnForm" label-width="80px">
						<el-form-item label="按钮名称">
							<el-input v-model="btnForm.name"></el-input>
						</el-form-item>
						<el-form-item label="所属菜单">
							<el-input v-model="btnForm.menu" readonly @click.native="dialogFormVisible = true"></el-input>
						</el-form-item>
						<el-form-item label="url">
							<el-input v-model="btnForm.url"></el-input>
						</el-form-item>
						<el-form-item label="排序">
							<el-input v-model="btnForm.sort"></el-input>
						</el-form-item>
						<el-form-item label="状态">
							<el-switch v-model="btnForm.status" active-color="#13ce66" inactive-color="#dcdfe6">
							</el-switch>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="BtnSubmit()">确认</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<el-dialog title="请选择菜单" :visible.sync="dialogFormVisible">
			<el-tree :data="treeData" node-key="id" :props="defaultProps" default-expand-all @node-click="handleNodeClick">
			</el-tree>
		</el-dialog>
		<el-dialog title="图标" :visible.sync="dialogVisible" width="50%">
			<div class="icons-container">
				<div v-for="item of elementIcons" :key="item" @click="handleClipboard(item)">

					<div class="icon-item">
						<i :class="item" />
						<span>{{ item }}</span>
					</div>

				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import elementIcons from '../../assets/icons/element-icons.js'
	export default {
		data() {
			return {
				form: {
					name: '',
					url: '',
					menu: '',
					sort: '',
					status: false,
					ico: ''

				},
				btnForm: {
					name: '',
					url: '',
					menu: '',
					sort: '',
					status: false,
				},
				//权限树
				treeData: [{
					id: 11,
					label: '目录',
				}, {

					id: 1,
					label: '系统管理',
					children: [{
							id: 5,
							label: '角色管理',
						}, {
							id: 6,
							label: '用户管理',
						},
						{
							id: 7,
							label: '部门管理',
						},
					]
				}],
				activeName: 'first',
				dialogFormVisible: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				elementIcons,
				dialogVisible: false
			}
		},
		created() {
			var row = JSON.parse(localStorage.getItem("row"));
			if (row != null) {
				this.form.name = row.menuName;
				this.form.url = row.url;
				this.form.type = row.type;
				this.form.sort = row.sort;
				this.form.status = row.status;
			} else {
				this.form.name = '';
				this.form.url = '';
				this.form.type = '';
				this.form.sort = '';
				this.form.status = '';
			}

		},
		methods: {
			goBack() {
				this.$router.go(-1);

			},
			handleClick(tab, event) {
				this.form.menu = '';
				this.btnForm.menu = '';
			},
			handleNodeClick(data) {
				this.$message({
					message: '选择了' + data.label,
					type: 'success'
				});
				this.form.menu = data.label;
				this.btnForm.menu = data.label;
			},
			onSubmit() {},
			//点击图标
			handleClipboard(item) {
				var iconName = item;
				this.form.ico = iconName;
				this.dialogVisible = false;
			},
		},
		beforeDestroy() {
			localStorage.clear();

		},
		destroyed() {
			localStorage.clear();
		}
	}
</script>

<style>
	.icons-container {
		margin: 10px 20px 0;
		overflow: hidden;
	}
	
	.icons-container .icon-item {
		margin: 20px;
		height: 40px;
		text-align: center;
		width: 100px;
		float: left;
		font-size: 18px;
		color: #24292e;
		cursor: pointer;
	}

	.icons-container .icon-item:hover {
		color: #006DCC;
	}
</style>



// WEBPACK FOOTER //
// src/components/system/add.vue